export enum CategoryAdditionalMarketingDataTypeEnum {
  Push_Card_Component = 'PUSH_CARD_COMPONENT',
  Argument = 'ARGUMENT',
  Push_Slider_Module = 'PUSH_SLIDER_MODULE',
  Product_Comparator = 'PRODUCT_COMPARATOR',
  Recipe_Card = 'RECIPE_CARD',
  Seo_Module = 'SEO_MODULE',
  Teaser = 'TEASER'
}
